import { Cookie } from 'ng2-cookies/ng2-cookies';
import { ValidacionCelService } from './service/validacion-cel.service';
import { NavController } from '@ionic/angular';
import { ProcesoEstadoService } from './service/proceso-estado.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, NavigationExtras } from '@angular/router';
import { Observable } from 'rxjs';
import { datosProceso } from './proceso-alta.guard';
import { AppComponent } from './app.component';
@Injectable({
  providedIn: 'root'
})
export class ValidacionEmpresaGuard implements CanActivate {
  CANTIDAD = 5;
  DIAS = 15;
  constructor(public proceso: ProcesoEstadoService, public validCel: ValidacionCelService, public router: Router, public navCtrl: NavController) {
  }
  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
      var resp=true;
      if(AppComponent.inError){
        return false;
      }

      if (!next.queryParamMap.has("param")) {
        var validador = parseInt(Cookie.get("validador"));
        console.log("validacionEmpresa");
        await this.proceso.validar().then(async (data: datosProceso) => {
    
          if(data.estado_cuenta==30){
            const navigationExtras: NavigationExtras = {
              queryParams: {
                param: JSON.stringify({ login: true,valida_empresa:true , mensaje: "Todavia falta un paso mas, revisa tu mail y segui los pasos."})
              }
            };
            this.navCtrl.navigateForward("home", navigationExtras);
            resp = true
          }
          return resp;
        }).catch(err=>{
    
          if(err=="El token es invalido"){
            this.navCtrl.navigateForward("home");
            return true;
          }
            
          return false;
        });
      }

      return resp;
    }
}
